module.exports = __webpack_public_path__ + "static/media/fcf-reports.e09fe449.svg";